export default {
  please_sign_in_first: 'Please sign in first',
  api_error_message: 'API error {{url}}: {{statusText}} ({{status}})',
  time_out: 'TimeOut',
  required_message: '{{name}} is required.',
  max_characters_50: 'Maximum 50 characters.',
};
